import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var FilterFunnel02 = function FilterFunnel02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M3.3859 5.6669c-.7563-.8453-1.1345-1.268-1.1488-1.6272a1 1 0 0 1 .3625-.8108C2.8768 3 3.444 3 4.5783 3h14.8429c1.1343 0 1.7015 0 1.9787.2289a1 1 0 0 1 .3625.8108c-.0143.3592-.3925.7819-1.1488 1.6272l-5.7062 6.3775c-.1508.1685-.2262.2528-.2799.3487a1 1 0 0 0-.1039.2717c-.0239.1073-.0239.2204-.0239.4465v5.3471c0 .1955 0 .2933-.0315.3779a.5.5 0 0 1-.1322.1952c-.0668.0607-.1576.097-.3391.1697l-3.4 1.36c-.3676.147-.5514.2205-.6989.1898a.5.5 0 0 1-.315-.2133c-.0832-.1255-.0832-.3235-.0832-.7193v-6.7071c0-.2261 0-.3392-.024-.4465a1 1 0 0 0-.1038-.2717c-.0537-.0959-.1291-.1802-.2799-.3487z"
    })
  }));
};
export default FilterFunnel02;